"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgeWithIcon = void 0;
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const Icon_1 = __importDefault(require("../Icon/Icon"));
const BadgeWithIcon = ({ type, children }) => {
    const classNames = classnames_1.default('badge-with-icon', `badge-with-icon-${type}`);
    const badgeIcon = () => {
        switch (type) {
            case 'success':
                return 'check_green';
            case 'warning':
                return 'excl_yellow';
            case 'error':
                return 'excl_red';
            default:
                return 'info_blue';
        }
    };
    return (React.createElement("div", { className: classNames },
        React.createElement(Icon_1.default, { icon: badgeIcon(), className: "badge-with-icon-icon-container" }),
        children));
};
exports.BadgeWithIcon = BadgeWithIcon;
//# sourceMappingURL=BadgeWithIcon.js.map